import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";
import {
  DESTINATION_TYPES,
  RULE_CONDITIONS,
  RULE_CONTROLS,
} from "../constants";

const generateForwardingRulesSchema = (rule) => {
  const ruleSchema = {
    destination: yup.object({
      destinationType: yup.string().oneOf(Object.keys(DESTINATION_TYPES)),
      destination: yup
        .string()
        .test("destination", "Wrong format", (value, ctx) => {
          if (
            ctx.parent.destinationType === DESTINATION_TYPES.EXTERNAL_NUMBER &&
            !/^[\d+\-\s]{1,25}$/.test(value)
          ) {
            return ctx.createError({
              // Remove the array index from the first part of the path
              // Pre: [index].forwardingRules.rule.destinations.destination
              // Post: forwardingRules.rule.destinations.destination
              path: ctx.options.path.split(".").slice(1).join("."),
              params: { index: ctx.options.index },
              message: "Value should be a phone number, maximum 25 characters",
            });
          }
          return true;
        }),
    }),
    priority: yup.string(),
    ruleControl: yup.string().oneOf(Object.keys(RULE_CONTROLS)),
  };
  if (rule === RULE_CONDITIONS.NO_ANSWER)
    ruleSchema.noAnswerForwardDelay = yup.number();

  return yup.object(ruleSchema);
};

const schema = yup.object({
  extension: yup.object({
    subscriptionId: yup.string().nullable(),
    extensionNumber: yup.string().nullable(),
    callerIdFirstName: yup.string().nullable(),
    callerIdLastName: yup.string().nullable(),
    primaryDID: yup.string().nullable(),
    serviceType: yup.string().nullable(),
    branch: yup.object({
      name: yup.string().nullable(),
    }),
  }),
  forwardingRules: yup.object({
    BUSY: generateForwardingRulesSchema(RULE_CONDITIONS.BUSY),
    NO_ANSWER: generateForwardingRulesSchema(RULE_CONDITIONS.NO_ANSWER),
    OUTAGE: generateForwardingRulesSchema(RULE_CONDITIONS.OUTAGE),
  }),
});

addKeyToFieldsRecursively(schema);

export default schema;
